import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Auto-scroll to top whenever the route pathname changes.
 * Without this, react-router preserves scroll position across
 * navigations and a freshly-opened page loads at the middle/bottom.
 * Hash links (#anchor) intentionally bypass this.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
};
